import { Dispatch, ThunkAction } from '../../../../../../../types/actions';

export const onTabBackgroundActive = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
    };
    return action;
};
